import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const SaltSchema = z.object({
  saltValue: z.instanceof(HexNumber),
})

type SaltProps = z.infer<typeof SaltSchema>

export class Salt extends ValueObject<SaltProps> {
  public getValue(): HexNumber {
    return this.props.saltValue
  }

  public static create(props: SaltProps): Salt {
    const validatedProps = SaltSchema.parse(props)
    return new Salt(validatedProps)
  }
}
